module.exports = __webpack_public_path__ + "img/19.08995faf.png";